/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { navItems } from "~/constants";
import { Product, ProductIdRouteParams, productInitialState } from "~/models";
import { ROUTES } from "~/routing";
import { useDetailsNotFound, useAxios } from "~/tools";

const useProduct = () => {
  const state = useParams<ProductIdRouteParams>();
  const { productId } = state;
  const [product, setProduct] = React.useState<Product>(productInitialState);
  const { detailsNotFound } = useDetailsNotFound();

  const { Axios } = useAxios();

  const fetchProduct = React.useCallback(async () => {
    try {
      const { data } = await Axios().get(`/catalog/products/${productId}`);
      setProduct(data);
    } catch (e) {
      detailsNotFound(ROUTES.productCatalog.index, navItems.productCatalog);
    }
  }, [Axios, detailsNotFound, productId]);

  React.useEffect(() => {
    fetchProduct();
  }, [fetchProduct]);

  return {
    product,
    fetchProduct,
  };
};

export { useProduct };
